exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dialog_height[data-v-316daab1]{\n    height: 100%;\n}\n.mypage-visit-input[data-v-316daab1] {\n    height: initial;\n    max-height: 100vh;\n    overflow-y: auto;\n}\n@media screen and (max-width: 896px) {\n.mypage-visit-input[data-v-316daab1]{\n        height: 95vh;\n        width: 90%;\n        margin: 10px auto;\n        overflow-y: scroll;\n}\n}\n\n", ""]);

// exports
